import { Button as BsButton } from "react-bootstrap";
import { Button } from "./components/Button";
import { PiCircle, PiCircleFill, PiSealFill, PiSealWarning, PiWarningCircle, PiWarningCircleFill } from "react-icons/pi";

export function ThemePage() {
    return <div className="p-4 w-100 h-100 d-flex justify-content-center">
        <div className="d-flex flex-column gap-2">
            <Button>Hey!</Button>
            <BsButton>Hey!</BsButton>
            <div className="bg-light">
                <PiWarningCircle style={{ position: "absolute" }} size={32} strokeWidth={12} color="blue" />
                <PiCircleFill size={32} strokeWidth={12} stroke="white" fill="white" />
            </div>
            <div className="bg-dark">
                <PiWarningCircle style={{ position: "absolute" }} size={32} strokeWidth={12} color="blue" />
                <PiCircleFill size={32} strokeWidth={12} stroke="white" fill="white" />
            </div>
            <div className="bg-dark">
                <PiSealWarning style={{ position: "absolute" }} size={32} strokeWidth={12} color="blue" />
                <PiSealFill size={32} strokeWidth={12} stroke="white" fill="white" />
            </div>
        </div>
    </div>;
}